import Title from '@/components/Title/index.vue';
import FuncList from '@/components/FuncList/index.vue';
export default {
  name: 'function',
  components: {
    Title,
    FuncList
  },
  data() {
    return {
      imageFunc: require('@/assets/images/service/phone-oem/function.png'),
      itemList: [{
        img: require('@/assets/images/service/shortsPlatform/shortsPlatform-automatic.png'),
        title: '自动创作，秒级生产',
        desc: '支持用户通过简单的拖拽、拼装与数据接入，创作专属视频模板。此外，我们还主要提供产业链诊断、大盘收评、风险早报、每周热股、财报解读、基金解读等视频模板，最快仅需10秒即可完成短视频的制作发布。'
      }, {
        img: require('@/assets/images/service/shortsPlatform/shortsPlatform-efficiency.png'),
        title: '辅助创作，提升效率',
        desc: '提供创作模板、图文素材、视频素材、可视化图表组件等素材与智能配色推荐、智能数据录入、标签检索等技术，在辅助视频创作者将复杂内容可视化的同时，全面提升视频创作效率。'
      }, {
        img: require('@/assets/images/service/shortsPlatform/shortsPlatform-conversation.png'),
        title: '一键转换，简单便捷',
        desc: '依托同花顺自然语言处理、多模态图片匹配等算法推出了一键文本转视频功能，只需要上传word文本或者输入资讯链接即可快速生成短视频。'
      }, {
        img: require('@/assets/images/service/shortsPlatform/shortsPlatform-anchor.png'),
        title: 'AI虚拟主播',
        desc: '依托同花顺真人3D模型、PTA、语音面部驱动、唇形匹配、肢体动作匹配等AI技术，可定制打造动物、卡通、真人等风格的虚拟主播及专属音库，满足各类场景需求。'
      }, {
        img: require('@/assets/images/service/shortsPlatform/shortsPlatform-terminals.png'),
        title: '多端平台，自动发布',
        desc: '模板视频无需人工干预即可一站式发布至同花顺、抖音等各大平台，支持定时发布及自定义设置各终端的发布形式，最大化助力内容曝光。'
      }, {
        img: require('@/assets/images/service/shortsPlatform/shortsPlatform-data.png'),
        title: '海量数据，随取随用',
        desc: '资讯新闻：资讯网站、政府机关、地方门户、上市公司、地方网站、股吧、论坛、自媒体等；金融数据：股票（国内外市场）、基金、债券、理财资管等；宏观EDB：覆盖了23个行业和100多个国家，包含了200w+宏观及行业经济数据指标'
      }]
    };
  }
};